(function() {
    'use strict';

    angular
        .module('completeAir')
        .factory('excelService', excelService);

    excelService.$inject = ['$window', '$timeout', 'FileSaver', 'Blob'];

    function excelService ($window, $timeout, FileSaver, Blob) {
        var uri='data:application/vnd.ms-excel;base64,',
            template='<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
            base64=function(s){return $window.btoa(unescape(encodeURIComponent(s)));},
            format=function(s,c){return s.replace(/{(\w+)}/g,function(m,p){return c[p];})};

        return {
            exportToExcel: exportToExcel,
            exportDataToExcel: exportDataToExcel
        };

        function tableToExcel (tableId, worksheetName) {
            var table=$(tableId);
            var ctx={worksheet:worksheetName,table:table.html()};
            var href=uri+base64(format(template,ctx));
            return href;
        }

        function exportToExcel(idTable) {
            var exportHref = tableToExcel(idTable, 'WireWorkbenchDataExport');
            $timeout(function(){
                location.href=exportHref;
            },100);
        }

        function exportDataToExcel(idContendExport, nameReport) {
            var datetimestamp = Date.now();
            var nameFile = nameReport + "_" + datetimestamp + ".xls";
            var header = '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';

            var blob = new Blob([header + document.getElementById(idContendExport).innerHTML], {
                type: "data:application/vnd.ms-excel;charset=UTF-8"});
            FileSaver.saveAs(blob, nameFile);
        }
    }
})();
